import { Component, inject } from '@angular/core';
import { ModalContainerComponent } from '../modal-container/modal-container.component';
import { ButtonComponent } from '@kinomap-dev/ng-ui-lib/buttons';
import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import { EmailSendModalData } from 'app/shared/models/modal.models';

@Component({
  selector: 'app-email-send-modal',
  imports: [ModalContainerComponent, ButtonComponent],
  templateUrl: './email-send-modal.component.html',
  styleUrl: './email-send-modal.component.scss',
})
export class EmailSendModalComponent {
  private dialogRef: DialogRef = inject(DialogRef);
  public data: EmailSendModalData = inject(DIALOG_DATA);

  onClose(): void {
    if (this.data?.onCancel) {
      this.data.onCancel();
    }
    this.dialogRef.close();
  }
}
